module.exports = __webpack_public_path__ + "img/chair_cool_off.baf70996.png";